/* ============================================================
   SANTJAKOV — buscador de la barra
   Mismo markup de resultados que el sitio estático (`.ns-head`, `.ns-item`,
   `.ns-nm`, `.ns-sub`, `.ns-pr`, `.ns-empty`), pero preguntando a Shopify en
   vez de filtrar un catálogo escrito en el navegador. Así encuentra cualquier
   prenda que Santi añada, sin tocar código.

   Al elegir una prenda se abre el DRAWER, igual que en el sitio; si por lo que
   sea no estuviera disponible, se navega a su ficha.
   ============================================================ */
(function(){
  const D=document;
  const campo=D.getElementById('navSearchInput');
  const caja=D.getElementById('navResults');
  if(!campo||!caja) return;

  const dinero=c=>'$'+(c/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:2});
  const limpio=s=>String(s||'').replace(/[<>&"]/g,m=>({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[m]));
  const cerrar=()=>{caja.classList.remove('open');campo.setAttribute('aria-expanded','false');};

  let filas=[], marcada=-1, ultima=0;

  function pintar(q,datos){
    let html='';
    const cols=(datos.collections||[]), prods=(datos.products||[]);
    if(cols.length) html+='<div class="ns-head">'+campo.dataset.tCats+'</div>'+cols.map(c=>
      `<button class="ns-item ns-cat" data-url="${limpio(c.url)}">
         <span class="ns-t"><span class="ns-nm">${limpio(c.title)}</span></span>
         <span class="ns-arrow">→</span></button>`).join('');
    if(prods.length) html+='<div class="ns-head">'+campo.dataset.tPiezas+'</div>'+prods.map(p=>{
      const img=p.featured_image&&p.featured_image.url?`<img src="${limpio(p.featured_image.url)}" alt="">`:'';
      const precio=(p.price_min!=null)?dinero(p.price_min):'';
      return `<button class="ns-item" data-handle="${limpio(p.handle)}" data-url="${limpio(p.url)}">
         ${img}
         <span class="ns-t"><span class="ns-nm">${limpio(p.title)}</span>
         <span class="ns-sub">${limpio(p.vendor||'')}</span></span>
         <span class="ns-pr">${precio}</span></button>`;}).join('');
    if(!html) html=`<div class="ns-empty">${campo.dataset.tNada.replace('%s','“'+limpio(q.trim())+'”')}</div>`;
    caja.innerHTML=html;
    caja.classList.add('open'); campo.setAttribute('aria-expanded','true');
    filas=[...caja.querySelectorAll('.ns-item')]; marcada=-1;
  }

  function buscar(q){
    const mio=++ultima;
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+
          '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(r=>r.json())
      .then(d=>{ if(mio===ultima) pintar(q,(d.resources&&d.resources.results)||{}); })
      /* una búsqueda que falla no debe dejar abierta la lista anterior: se
         cierra, que es menos confuso que enseñar resultados de otra palabra */
      .catch(()=>{ if(mio===ultima) cerrar(); });
  }

  let temporizador;
  campo.addEventListener('input',()=>{
    const q=campo.value;
    clearTimeout(temporizador);
    if(!q.trim()){ cerrar(); caja.innerHTML=''; filas=[]; return; }
    /* 220 ms: lo justo para no pedir una vez por tecla */
    temporizador=setTimeout(()=>buscar(q),220);
  });

  caja.addEventListener('click',ev=>{
    const el=ev.target.closest('.ns-item'); if(!el) return;
    ev.preventDefault();
    cerrar();
    if(el.dataset.handle && window.abrirFicha) window.abrirFicha(el.dataset.handle);
    else if(el.dataset.url) location.href=el.dataset.url;
  });

  const marcar=d=>{
    if(!filas.length) return;
    marcada=(marcada+d+filas.length)%filas.length;
    filas.forEach((el,i)=>el.classList.toggle('on',i===marcada));
    filas[marcada].scrollIntoView({block:'nearest'});
  };
  campo.addEventListener('keydown',e=>{
    if(e.key==='ArrowDown'){e.preventDefault();marcar(1);}
    else if(e.key==='ArrowUp'){e.preventDefault();marcar(-1);}
    else if(e.key==='Enter'&&marcada>=0){e.preventDefault();filas[marcada].click();}
    /* Enter SIN una sugerencia marcada lleva a la página de resultados. El campo
       no vive dentro de un `<form>` —la barra es una rejilla y meterlo en uno
       cambiaría su medida—, así que sin esto la tecla no hacía nada y la página
       de búsqueda era inalcanzable desde la interfaz. Se piden también las
       categorías: quien escribe «hoodie» normalmente quiere la categoría
       entera, no una prenda suelta. */
    else if(e.key==='Enter'){
      const q=campo.value.trim();
      if(!q) return;
      e.preventDefault(); cerrar();
      const ir=window.irA||(u=>{location.href=u;});
      ir('/search?q='+encodeURIComponent(q)+'&type=product,collection');
    }
    else if(e.key==='Escape'){cerrar();campo.blur();}
  });
  D.addEventListener('click',e=>{ if(!e.target.closest('#navSearch')) cerrar(); });
})();
